import { useState } from 'react';
import { toast } from 'react-toastify';

export default function useViewApplicationModal(http) {

    const [showViewModal, setShowViewModal] = useState(false);
    const [viewData, setViewData] = useState(null);
    const [viewLoading, setViewLoading] = useState(false);
    const [pdfLoading, setPdfLoading] = useState({});
    const [pdfModal, setPdfModal] = useState({ show: false, url: '', name: '', type: '' });

    const openViewModal = async (student) => {
        setShowViewModal(true);
        setViewData(null);
        setViewLoading(true);
        try {
            const res = await http.post('/College/getStudentCreditApplication', {
                account_id: student.accountid,
                credit_id: student.id,
            });
            if (res.data.status) {
                setViewData(res.data.data);
            } else {
                toast.error('Failed to load application details.');
                setShowViewModal(false);
            }
        } catch (err) {
            console.error('Error fetching application details:', err);
            toast.error('Something went wrong while loading details.');
            setShowViewModal(false);
        } finally {
            setViewLoading(false);
        }
    };

    const closeViewModal = () => {
        setShowViewModal(false);
        setViewData(null);
        closePdfModal();
    };

    const openPdfModal = async (encryptedFile, fileName) => {
        setPdfLoading(prev => ({
            ...prev,
            [encryptedFile]: true
        }));
        try {
            const res = await http.get(
                `/College/fetchSecureExternalCreditPdf/${encodeURIComponent(encryptedFile)}`,
                { responseType: 'blob' }
            );
            const contentType = res.headers['content-type'];
            const blobUrl = URL.createObjectURL(
                new Blob([res.data], { type: contentType })
            );
            setPdfModal({ show: true, url: blobUrl, name: fileName, type: contentType });
        } catch (err) {
            console.error('Error fetching file:', err);
            toast.error('Failed to load document. Please try again.');
        } finally {
            setPdfLoading(prev => ({
                ...prev,
                [encryptedFile]: false
            }));
        }
    };

    const closePdfModal = () => {
        if (pdfModal.url) URL.revokeObjectURL(pdfModal.url);
        setPdfModal({ show: false, url: '', name: '', type: '' });
    };

    return {
        showViewModal,
        viewData,
        viewLoading,
        pdfLoading,
        pdfModal,
        openViewModal,
        closeViewModal,
        openPdfModal,
        closePdfModal,
    };
}